import React from "react";
import { motion } from "framer-motion";
import {
  Search,
  Database,
  Wrench,
  BarChart3,
  Rocket,
  RefreshCw,
  type LucideIcon,
} from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

type Step = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

const steps: Step[] = [
  { number: "01", title: "Discovery", description: "Understand business goals, data sources, and key metrics.", icon: Search },
  { number: "02", title: "Data Audit", description: "Assess data quality, gaps, and infrastructure readiness.", icon: Database },
  { number: "03", title: "Architecture Design", description: "Plan pipelines, warehouses, and dashboard structure.", icon: Wrench },
  { number: "04", title: "Build & Integrate", description: "Develop ETL pipelines, models, and BI dashboards.", icon: BarChart3 },
  { number: "05", title: "Deploy & Train", description: "Launch solutions and train your team on tools and insights.", icon: Rocket },
  { number: "06", title: "Optimize & Scale", description: "Refine models, add data sources, and expand analytics scope.", icon: RefreshCw },
];

const DaProcess: React.FC = () => (
  <AnimatedSection as="section" className="da-section da-section--light" aria-labelledby="da-process-title">
    <div className="da-container">
      <SectionHeader
        eyebrow="Our Process"
        title="How We Deliver Data Analytics Success"
        text="A proven 6-step framework from data discovery to continuous optimization."
        light
      />

      <div className="da-process">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.title}
              className="da-process__step"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
            >
              <div className="da-process__badge">{step.number}</div>
              <div className="da-process__icon">
                <Icon size={20} aria-hidden="true" />
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </AnimatedSection>
);

export default DaProcess;
